import React, { useState, useEffect, useMemo } from "react";
import MasterDataFormV2 from "pages/POS/MasterDataFormV2";
import { getRequest } from "services/api";

const ATVForm = ({ initialData, onSuccess, onError }) => {
  const [statuses, setStatuses] = useState([]);

  // Calculate default dates
  const defaultDates = useMemo(() => {
    const today = new Date();
    const nextMonth = new Date(today);
    nextMonth.setMonth(today.getMonth() + 1);

    // Find "Siap Pakai" status
    const siapPakaiStatus = statuses.find(
      (status) => status.label === "Siap Pakai"
    );

    return {
      last_service: today.toISOString().split("T")[0], // Today in YYYY-MM-DD format
      next_service: nextMonth.toISOString().split("T")[0], // Next month in YYYY-MM-DD format
      atv_validity: 4, // Default 4 years validity
      year: today.getFullYear(), // Default current year
      status_id: siapPakaiStatus ? siapPakaiStatus.value : "", // Default "Siap Pakai" status
    };
  }, [statuses]);

  // Fetch statuses for dropdown
  useEffect(() => {
    const fetchStatuses = async () => {
      try {
        const response = await getRequest("/atv-status");
        if (response.success) {
          setStatuses(
            response.data.map((status) => ({
              value: status.id,
              label: status.name,
            }))
          );
        }
      } catch (error) {
        console.error("Error fetching statuses:", error);
      }
    };

    fetchStatuses();
  }, []);

  return (
    <MasterDataFormV2
      title="ATV"
      apiUrl="/atv"
      initialData={{
        ...defaultDates,
        ...initialData,
      }}
      fields={[
        {
          name: "plate_number",
          label: "Plate Number",
          type: "text",
          required: true,
          placeholder: "Enter plate number",
        },
        {
          name: "name",
          label: "Name",
          type: "text",
          required: true,
          placeholder: "Enter ATV name",
        },
        {
          name: "model",
          label: "Model",
          type: "text",
          // required: true,
          placeholder: "Enter model",
        },
        {
          name: "year",
          label: "Year",
          type: "number",
          // required: true,
          placeholder: "Enter year",
        },
        // {
        //   name: "chassis_number",
        //   label: "Chassis Number",
        //   type: "text",
        //   // required: true,
        //   placeholder: "Enter chassis number",
        // },
        // {
        //   name: "engine_number",
        //   label: "Engine Number",
        //   type: "text",
        //   // required: true,
        //   placeholder: "Enter engine number",
        // },
        {
          name: "atv_validity",
          label: "ATV Validity (Years)",
          type: "number",
          required: true,
          placeholder: "Enter validity in years",
        },
        {
          name: "status_id",
          label: "Status",
          type: "select",
          required: true,
          options: statuses,
          placeholder: "Select status",
        },
        {
          name: "last_service",
          label: "Last Service",
          type: "date",
          required: true,
        },
        {
          name: "next_service",
          label: "Next Service",
          type: "date",
          required: true,
        },
      ]}
      onSuccess={onSuccess}
      onError={onError}
    />
  );
};

export default ATVForm;
